import classNames from 'classnames';

import styles from './_index.module.scss';

export const BadgeVariant = {
  beta: 'beta',
  default: 'default',
  error: 'error',
  info: 'info',
  success: 'success',
} as const;
export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  label: React.ReactNode;
  variant?: (typeof BadgeVariant)[keyof typeof BadgeVariant];
}

const Badge = ({ className, label, variant = BadgeVariant.default, ...props }: BadgeProps) => {
  return (
    <span className={classNames(styles[`badge-${variant}`], className)} {...props}>
      {label}
    </span>
  );
};

export default Badge;
